import React from 'react';
import cx from 'classnames';

export default function IconPlus({
  className,
  onClick,
}: {
  className?: string;
  onClick?: (e: React.MouseEvent) => void;
}) {
  return (
    <svg
      className={cx(className, 'icon icon-plus')}
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg"
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="#6A4192"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.39999 4.4V0.800003H5.59999V4.4H9.19999V5.6H5.59999V9.2H4.39999V5.6H0.799988V4.4H4.39999Z"
      />
    </svg>
  );
}
